import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('practica');

export class EnrollmentByException extends Api {
  constructor(http, config = {}) {
    super(http, url, 'enrollment-by-exception', config);
  }
}